import { useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import InventoryManagement from './InventoryManagement';
import EmployeeManagement from './EmployeeManagement';
import TimecardSystem from './TimecardSystem';
import KioskMenuManagement from './KioskMenuManagement';
import LoyaltyManagement from './LoyaltyManagement';
import SalesAnalytics from './SalesAnalytics';
import CustomerFeedback from './CustomerFeedback';
import RealTimeOrders from './RealTimeOrders';
import './App.css';

const App = () => {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [tab, setTab] = useState('inventory');
  const [employees, setEmployees] = useState([]);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async user => {
      setUser(user);
      if (user) {
        console.log('User UID:', user.uid);
        const employeeDoc = await getDoc(doc(db, 'employees', user.uid));
        if (employeeDoc.exists()) {
          const role = employeeDoc.data().role || 'employee';
          console.log('User Role:', role);
          setUserRole(role);
        } else {
          console.log('No employee document found for UID:', user.uid);
          if (user.email.endsWith('@kactuskwenchers.com')) {
            console.log('Granting admin access based on email');
            setUserRole('admin');
          } else {
            setUserRole('employee');
          }
        }
      } else {
        setUserRole(null);
      }
    });
    return unsubscribe;
  }, []);

  const login = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      alert('Login failed: ' + error.message);
    }
  };

  const logout = async () => {
    await signOut(auth);
  };

  const hasAccess = (requiredRole) => {
    if (!userRole) return false;
    if (userRole === 'admin') return true;
    if (requiredRole === 'manager' && userRole === 'manager') return true;
    return false;
  };

  return (
    <div>
      {!user ? (
        <div className="login-container">
          <div className="login-box">
            <h1>Kactus Admin Login</h1>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Email"
            />
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Password"
            />
            <button onClick={login}>Login</button>
          </div>
        </div>
      ) : (
        <div className="dashboard">
          <div className="sidebar">
            <h2>Kactus Admin</h2>
            {hasAccess('admin') && (
              <button
                className={tab === 'employees' ? 'active' : ''}
                onClick={() => setTab('employees')}
              >
                Employees
              </button>
            )}
            <button
              className={tab === 'inventory' ? 'active' : ''}
              onClick={() => setTab('inventory')}
            >
              Inventory
            </button>
            <button
              className={tab === 'timecards' ? 'active' : ''}
              onClick={() => setTab('timecards')}
            >
              Timecards
            </button>
            {(hasAccess('admin') || hasAccess('manager')) && (
              <button
                className={tab === 'kioskMenu' ? 'active' : ''}
                onClick={() => setTab('kioskMenu')}
              >
                Kiosk Menu
              </button>
            )}
            {(hasAccess('admin') || hasAccess('manager')) && (
              <button
                className={tab === 'loyalty' ? 'active' : ''}
                onClick={() => setTab('loyalty')}
              >
                Loyalty Program
              </button>
            )}
            {(hasAccess('admin') || hasAccess('manager')) && (
              <button
                className={tab === 'sales' ? 'active' : ''}
                onClick={() => setTab('sales')}
              >
                Sales Analytics
              </button>
            )}
            {(hasAccess('admin') || hasAccess('manager')) && (
              <button
                className={tab === 'feedback' ? 'active' : ''}
                onClick={() => setTab('feedback')}
              >
                Customer Feedback
              </button>
            )}
            {(hasAccess('admin') || hasAccess('manager')) && (
              <button
                className={tab === 'realtimeOrders' ? 'active' : ''}
                onClick={() => setTab('realtimeOrders')}
              >
                Real-Time Orders
              </button>
            )}
            <button className="logout-button" onClick={logout}>
              Logout
            </button>
          </div>
          <div className="main-content">
            <h1>Admin Dashboard</h1>
            {tab === 'employees' && hasAccess('admin') && <EmployeeManagement user={user} setEmployees={setEmployees} />}
            {tab === 'inventory' && <InventoryManagement user={user} />}
            {tab === 'timecards' && <TimecardSystem user={user} employees={employees} />}
            {tab === 'kioskMenu' && (hasAccess('admin') || hasAccess('manager')) && <KioskMenuManagement user={user} />}
            {tab === 'loyalty' && (hasAccess('admin') || hasAccess('manager')) && <LoyaltyManagement user={user} />}
            {tab === 'sales' && (hasAccess('admin') || hasAccess('manager')) && <SalesAnalytics user={user} />}
            {tab === 'feedback' && (hasAccess('admin') || hasAccess('manager')) && <CustomerFeedback user={user} />}
            {tab === 'realtimeOrders' && (hasAccess('admin') || hasAccess('manager')) && <RealTimeOrders user={user} />}
          </div>
        </div>
      )}
    </div>
  );
};

export default App;